import styled from 'styled-components';

export const StyledDeviceActivationCode = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const StyledButton = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
`;

export const StyledTimerSpan = styled.span`
  padding: 0px 5px;
  font-weight: bold;
`;
